import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const DynamicFormsList = Loadable(
  lazy(() =>
    import("./dynamicFormsList").then(({ DynamicFormsList }) => ({
      default: DynamicFormsList,
    }))
  )
);

const ManageDynamicForms = Loadable(
  lazy(() =>
    import("./manageDynamicForms").then(({ ManageDynamicForms }) => ({
      default: ManageDynamicForms,
    }))
  )
);

export const dynamicFormsRoutesV2 = [
  {
    path: "/dynamic-forms",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleIds={[]}>
        <DynamicFormsList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/dynamic-forms/manage",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleIds={[]}>
        <ManageDynamicForms />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/dynamic-forms/manage/:masterFormId",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleIds={[]}>
        <ManageDynamicForms />
      </AuthorizedRoute>
    ),
  },
];
